export default __webpack_public_path__ + "static/pig08-ae14ce54375c95da157968372f93e355.png";